// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__35Emn","text":"SelectPayment_text__2hO3_","title":"SelectPayment_title__zZ5-2","btn":"SelectPayment_btn__3nNP-"};